// extracted by mini-css-extract-plugin
export default {"Container":"CompanyProfile_Container__IWPbT","LeftCol":"CompanyProfile_LeftCol__2ZUYW","RightCol":"CompanyProfile_RightCol__1ciqz","Body":"CompanyProfile_Body__10KVd"};